import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import FavCards from "./FavCards";
import SearchIcon from "@mui/icons-material/Search";
import { styled, alpha } from "@mui/material/styles";
import InputBase from "@mui/material/InputBase";
import { useGetAllMealPlanQuery } from "api/Mealplans";
import { useGetFavouritesQuery } from "api/menu";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(3),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
}));

const Favourite = () => {

  // const { data: AllMeal, isloading } = useGetAllMealPlanQuery()
  const { data: AllFavour, isLoading } = useGetFavouritesQuery()
  // console.log("AllMeal", AllMeal)
  console.log("AllFavour", AllFavour)
  const profile = JSON.parse(localStorage.getItem("user"))
  console.log("profile", profile?.profile?._id)

  const [filterFavourite, setFilterFavourite] = useState([])

  useEffect(() => {
    // for (let i of AllFavour?.data) {
    //   for (let j of i.favourite) {
    //     console.log("j", j)

    //   }
    // }
    const filter = AllFavour?.data.filter((meal) => {

      return meal?.favourite?.some((mealFilter) => {
        return mealFilter === profile?.profile?._id;
      });


      //  meal?.favourite?.filter((mealFilter) => {
      //   // const filterFav = meal?.favourite?.filter((mealFilter) => {
      //   console.log("mealFilter", mealFilter)
      //   return mealFilter === profile?.profile?._id
      // })
      // console.log("filterFav", filterFav)
      // return filterFav
    })
    console.log("filter", filter)
    setFilterFavourite(filter)
    // const filterFavourite = filter?.filter((meal)=>)
  }, [AllFavour?.data])




  return (
    <Box sx={{ mt: "50px" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
          mb: "30px",
        }}
      >
        <Box sx={{ margin: "15px" }}>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "24px",
            }}
          >
            Favorites
          </Typography>
        </Box>
        <Box>
          <Search
            sx={{
              display: { xs: "none", sm: "block" },
              backgroundColor: "#E1E1E6",
              "&:hover": { backgroundColor: "#E1E1E6" },
            }}
          >
            <SearchIconWrapper>
              <SearchIcon sx={{ color: "#9EA3AE" }} />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search"
              inputProps={{ "aria-label": "search" }}
            />
          </Search>
        </Box>
      </Box>
      <FavCards filterFavourite={filterFavourite} />
    </Box>
  );
};

export default Favourite;
